// Reconoce familias lingüísticas. Los datos viven en data/word-families-es.json.
import familyData from '../data/word-families-es.json';
import { normalizeForLookup } from '../utils/unicode.js';

export class WordFamilyManager {
  constructor(families = familyData.families) {
    this.families = families.map((f) => ({
      ...f,
      normMembers: f.members.map((m) => normalizeForLookup(m)),
    }));
  }

  /** ¿A qué familias pertenece una palabra? */
  familiesOf(word) {
    const n = normalizeForLookup(word);
    return this.families.filter((f) => f.normMembers.includes(n));
  }

  /**
   * Comprueba qué familias quedan COMPLETADAS por un conjunto de palabras descubiertas.
   * @param {Set<string>} discoveredNorm palabras normalizadas ya creadas por el jugador
   * @returns {Array} familias recién completadas
   */
  completedFamilies(discoveredNorm) {
    return this.families.filter((f) => f.normMembers.every((m) => discoveredNorm.has(m)));
  }

  /** ¿Dos palabras son de la misma familia? (para bonificar evolución) */
  sameFamily(a, b) {
    const na = normalizeForLookup(a);
    const nb = normalizeForLookup(b);
    return this.families.some((f) => f.normMembers.includes(na) && f.normMembers.includes(nb));
  }
}
